(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/game-handler/assets/javascripts/game-handler.js') >= 0) return;  svs.modules.push('/components/ticketgames/game-handler/assets/javascripts/game-handler.js');
"use strict";


if (svs.utils.ns.isNamespace('svs.gameHandler.data.games')) {
  const getPackageGameConfig = svs.ticketgames.gameHandler.helpers.getPackageGameConfig;
  const mapScratchTicketsFromContentList = svs.ticketgames.gameHandler.mapScratchTicketsFromContentList;
  const _svs$gameHandler$data = svs.gameHandler.data.games,
    packageGameConfig = _svs$gameHandler$data.packageGameConfig,
    _svs$gameHandler$data2 = _svs$gameHandler$data.cntTicketGames,
    cntTicketGames = _svs$gameHandler$data2 === void 0 ? [] : _svs$gameHandler$data2;
  const games = mapScratchTicketsFromContentList([], cntTicketGames, [], svs.core.detect.feature('ft-soft-launch-ticket'));
  setGlobal('svs.ticketgames.gameHandler.getPackageGame', function () {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : packageGameConfig;
    let allGames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : games;
    return getPackageGameConfig(config, allGames);
  });
}

 })(window);